import React, { FC, ReactNode } from 'react';

type Props = {
    label: ReactNode;
    tooltip: string;
};

const HeaderCell: FC<Props> = ({ tooltip, label }) => (
    <div title={tooltip} className="rt-header-cell">
        {label}
    </div>
);

export default React.memo(HeaderCell);
